import React from "react";
import styled from "styled-components";

import {
  Button,
  ButtonType
} from "src/library/components/Button";

export interface IFixedBottomMenuActionProps {
  name: string;
  disabled?: boolean;
  onClick: () => void;
  $buttonType?: ButtonType;
  loading?: boolean;
}

export interface FixedBottomMenuProps {
  onClose: () => void;
  actions?: IFixedBottomMenuActionProps[];
  onCloseText?: string;
}

/**
 * A sticky menu view that appears at the bottom of page
 *
 * @returns a horizontal menu react element
 */
export const FixedBottomMenu: React.ReactFCWithChildren<FixedBottomMenuProps> = ({
  onClose,
  actions,
  onCloseText = "Close"
}) => {
  return (
    <MenuItemContainer>
      {onClose && (
        <Button
          size="small"
          $buttonType="secondary"
          onClick={onClose}
        >
          {onCloseText}
        </Button>
      )}

      {actions && actions.map((action, index) => (
        <Button
          key={index}
          disabled={action.disabled}
          $buttonType={action.$buttonType}
          onClick={() => action.onClick()}
          loading={action.loading}
        >
          {action.name}
        </Button>
      ))}
    </MenuItemContainer>
  );
};

const MenuItemContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;
